// extracted by mini-css-extract-plugin
export default {"rating":"Uz-z","numberOfStars":"Vz-z","count":"Wz-z","barGraphSpacing":"Xz-z","barGraph":"Yz-z"};